import React, { createContext } from 'react';
import { FUNNELS } from '../../util/constants';
// Create the context and add a defaultValue of `ARHI`
const FunnelContext = createContext({
  funnel: FUNNELS.ARHI
});
export const FunnelProvider = props => React.createElement(FunnelContext.Provider, {
  value: props.value
}, props.children);
export const FunnelConsumer = FunnelContext.Consumer;
export const AddFunnelPropFromContext = props => React.createElement(FunnelContext.Consumer, null, value => props.children && React.cloneElement(props.children, {
  funnel: value.funnel
}));